import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import LinkBuilder from 'helpers/link-builder';
import ApplyPositionForm from 'components/ApplyPositionForm';
import { DateHelpers } from 'helpers/date-helpers';

const TypeProcess = props => {
  const {
    post: {
      ProcessID,
      ProcessType,
      ApplicationProcessID,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      NewsFeedDateAdd,
      Date,
      PositionTitle,
    },
    options: { showDialog = false, hideProcessLink = false },
    actions: {
      onClickDialogButtonNo,
      onClickDialogButtonYes,
      checkPermissions,
    },
  } = props;

  const link = hideProcessLink
    ? '#'
    : ProcessType === 'Job'
    ? LinkBuilder.getJobLink(ProcessID)
    : LinkBuilder.getProjectLink(ProcessID);

  const firmLink =
    FirmActive === 'Yes' ? (
      <NavLink to={LinkBuilder.getFirmLink(FirmUrlAlias)}>{FirmName}</NavLink>
    ) : (
      <span className="feed-post-content__firm-name-span">{FirmName}</span>
    );

  const handleClickOnProcessLink = e => {
    if (!checkPermissions()) {
      e.preventDefault();
    }
  };

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        {firmLink}
        <div className="feed-post-content__text">is hiring —</div>
        <NavLink
          className="feed-post-content__postition"
          to={link}
          onClick={handleClickOnProcessLink}
        >
          {PositionTitle}
        </NavLink>
      </div>
      <div className="feed-post-content__date">{date}</div>
      {showDialog && !ApplicationProcessID && (
        <div className="feed-post-content__middle">
          <ApplyPositionForm
            onRefuseHandler={onClickDialogButtonNo}
            onApplyHandler={onClickDialogButtonYes}
          />
        </div>
      )}
    </div>
  );
};

export default TypeProcess;
